/**
 * WebGL 能力プローブ（FR-FLIP-03）。
 * three.js を import しない — 2D 経路しか使わない環境で 3D 一式を読み込ませないため。
 */

let cached: boolean | null = null;

/**
 * WebGL が使えるか。使い捨ての canvas でコンテキスト生成を試し、結果を記憶する。
 * 生成できた場合は WEBGL_lose_context で直ちに手放す（GL コンテキスト数の上限を食わない）。
 */
export function isWebglSupported(doc: Document = document): boolean {
  if (cached !== null) return cached;
  try {
    const canvas = doc.createElement('canvas');
    const gl = (canvas.getContext('webgl2') ??
      canvas.getContext('webgl')) as WebGLRenderingContext | null;
    cached = Boolean(gl);
    gl?.getExtension('WEBGL_lose_context')?.loseContext();
  } catch {
    cached = false;
  }
  return cached;
}

/** テストのためにプローブ結果を捨てる。 */
export function resetWebglSupportCache(): void {
  cached = null;
}
